import Card from './components/card'
import Logo from './components/logo'
import Barcode from './components/barcode'
import HeroImage from './components/hero-image'
import Fields from './components/fields'
import Header from './components/header'
import GoogleIcons from './components/google-icons'
import GoogleAppLink from '/components/editor/google/fronts/components/app-link'

const GoogleOfferFront = ({ show, backgroundColour, googleDarkBackgroundColour, fgColour }) => {
  try {
    return (
    <>
      <Card backgroundColour={backgroundColour} googleDarkBackgroundColour={googleDarkBackgroundColour} fgColour={fgColour}>
        <GoogleIcons show={show}/>
        <Logo />
        <div className="inset offer">
          <Header />
        </div>
        <Barcode />
        <div className="inset">
          <Fields />
          <GoogleAppLink />
        </div>
      </Card>
      <HeroImage/>
    </>
    )
  }
  catch (err) {
    throw err
  }
}

export default GoogleOfferFront